import { Scrollbars } from "react-custom-scrollbars-with-mac-support";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
const ResourcesFilterDropdown = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "filters" });
  const totolhotline = useSelector((index) => index.totolhotline);
  const totolphysical = useSelector((index) => index.totolphysical);
  return (
    <div class="select-dropdown">
      <div className="filter-title">
        <h3 className="header-four">{t("resources_include")}</h3>
        <button
          className="close-box"
          aria-label={t("close")}
          onClick={props.closeResourcesFilter}
        >
          <i class="btb bt-times"></i>
        </button>
      </div>

      <div className="filter-body">
        
        <Scrollbars
          style={props.getWindowWidth > 991.98 && { height: 120 }}
          renderTrackVertical={(props) => (
            <div {...props} className="track-vertical" />
          )}
          renderThumbVertical={(props) => (
            <div {...props} className="thumb-vertical" />
          )}
          className={`filter-options ${props.getTotolhotline > 0 && totolphysical !== 0 ? "hide-scrollBar-en":"hide-scrollBar"}`}
        >
          <div className="form-check">
            <input
              type="checkbox"
              value="any"
              id="show_all_helpline"
              checked={
                props.getResourceType.indexOf("any") != -1 ? "checked" : ""
              }
              onClick={props.getChangeResourceType}
            />
            <label for="show_all_helpline">{t("show_all")}</label>
          </div>
          {props.getTotolhotline > 0 && (
            <div className="form-check">
              <input
                type="checkbox"
                id="helpline_filter"
                value="hotline"
                checked={
                  props.getResourceType.indexOf("hotline") != -1
                    ? "checked"
                    : ""
                }
                onClick={props.getChangeResourceType}
              />
              <label for="helpline_filter">
                <span
                  class="bts bt-phone"
                  aria-hidden="true"
                  style={{ color: "#BE1488" }}
                ></span>
                <span role="text">
                  {" "}
                  {t("helplines")} /{" "}
                  <span
                    class="bts bt-desktop"
                    aria-hidden="true"
                    style={{ color: "#001489" }}
                  ></span>{" "}
                  {t("online_services")}
                </span>{" "}
                ({totolhotline})
              </label>
            </div>
          )}
          {totolphysical !== 0 && (
            <div className="form-check">
              <input
                type="checkbox"
                value="physical"
                id="physical_location_filter"
                onClick={props.getChangeResourceType}
                checked={
                  props.getResourceType.indexOf("physical") != -1
                    ? "checked"
                    : ""
                }
              />
              <label for="physical_location_filter">
                <span class="map-pin-icon" aria-hidden="true"></span> {t("physical_location")} ({totolphysical})
              </label>
            </div>
          )}
        </Scrollbars>
      </div>
      <div className="button-set">
        <button
          onClick={props.getPopulateDropdowns}
          className="button button__full-background button__full-background--bg-blue  button__full-background--color-white button__full-background--rounded button--font-family-helvetica-bold-rounded button__full-background--xs mr-sm-3 position-relative"
        >
          {t("show_results")}
        </button>
        <button
          className="button button__full-background button__full-background--rounded button--font-family-helvetica-bold-rounded  button__full-background--xs cancel-button"
          onClick={props.closeResourcesFilter}
        >
          {t("cancel")}
        </button>
      </div>
    </div>
  );
};
export default ResourcesFilterDropdown;
